<p>
  OMB No.0938-1236 |
  <a
    href="https://www.cms.gov/Regulations-and-Guidance/Legislation/PaperworkReductionActof1995/index"
    target="_blank"
    >Paperwork Reduction Act</a
  >
</p>

<h5 class="fw-bold">Consent to Monitoring</h5>
<p>
  By logging onto this website, you consent to be monitored. Unauthorized
  attempts to upload information and/or change information on this web site are
  strictly prohibited and are subject to prosecution under the
  <a
    href="https://www.congress.gov/bill/99th-congress/house-bill/4718"
    target="_blank"
    >Computer Fraud and Abuse Act of 1986</a
  >,
  <a
    href="https://uscode.house.gov/view.xhtml?req=(title:18%20section:1001%20edition:prelim)%20OR%20(granuleid:USC-prelim-title18-section1001)&f=treesort&edition=prelim&num=0&jumpTo=true"
    target="_blank"
    >Title 18 U.S.C. Sec. 1001</a
  >, and
  <a
    href="https://uscode.house.gov/view.xhtml?req=(title:18%20section:1030%20edition:prelim)%20OR%20(granuleid:USC-prelim-title18-section1030)&f=treesort&edition=prelim&num=0&jumpTo=true"
    target="_blank"
    >Title 18 U.S.C. Sec. 1030</a
  >. We encourage you to read the
  <a
    href="https://security.cms.gov/policy-guidance/hhs-policy-rules-behavior-use-information-it-resources"
    target="_blank"
    >HHS Rules of Behavior</a
  >.
</p>

<h5 class="fw-bold">Protecting Your Privacy</h5>
<p>
  Protecting your Privacy is a top priority at CMS. We are committed to ensuring
  the security and confidentiality of the user registering to HARP. Please read
  the
  <a
    href="https://www.cms.gov/Research-Statistics-Data-and-Systems/Computer-Data-and-Systems/Privacy/PrivacyActof1974"
    target="_blank"
    >CMS Privacy Act Statement</a
  >
  which describes how we use the information you provide.
</p>

<h5 class="fw-bold">Collection Of Personal Identifiable Information (PII)</h5>
<p>
  "Personal" information is described as data that is unique to an individual,
  such as a name, address, telephone number, social security number and date of
  birth (DOB).
</p>
<p>
  CMS is very aware of the privacy concerns around PII data. In fact, we share
  your concerns. We will only collect personal data to uniquely identify the
  user registering with the system. We may also use your answers to the
  challenge questions and other PII to later identify you in case you forget or
  misplace your User ID/Password.
</p>
<p>
  I have read the
  <a
    href="https://security.cms.gov/policy-guidance/hhs-policy-rules-behavior-use-information-it-resources"
    target="_blank"
    >HHS Rules of Behavior (HHS RoB)</a
  >
  and understand and agree to comply with its provisions. I understand that
  violations of the HHS RoB or information security policies and standards may
  lead to disciplinary action, up to and including termination of employment;
  removal or debarment from work on Federal contracts or projects; and/or
  revocation of access to Federal information, information systems, and/or
  facilities; and may also include criminal penalties and/or imprisonment. I
  understand that exceptions to the HHS RoB must be authorized in advance in
  writing by the OPDIV Chief Information Officer or his/her designee. I also
  understand that violation of laws, such as the
  <a
    href="https://www.cms.gov/Research-Statistics-Data-and-Systems/Computer-Data-and-Systems/Privacy/PrivacyActof1974"
    target="_blank"
    >Privacy Act of 1974</a
  >,
  <a href="https://www.copyright.gov/title17/" target="_blank">copyright law</a
  >, and
  <a
    href="https://uscode.house.gov/view.xhtml?req=(title:18%20section:2071%20edition:prelim)%20OR%20(granuleid:USC-prelim-title18-section2071)&f=treesort&edition=prelim&num=0&jumpTo=true"
    target="_blank"
    >Title 18 U.S.C. Sec. 2071</a
  >, which the HHS RoB draw upon, can result in monetary fines and/or criminal
  charges that may result in imprisonment.
</p>

<h5 class="fw-bold">External Service Consent</h5>

<p>
  You understand that by registering for HARP, you are providing 'written
  instructions' to CMS under the Fair Credit Reporting Act authorizing CMS to
  obtain information from your personal credit profile or other information from
  Experian. You authorize CMS to obtain such information solely to provide you
  access to personally identifiable information and prevent fraudulent
  transactions.
</p>

<p>
  CMS may need to verify mobile phone data through an external service provided
  by Twilio, Inc. You authorize your wireless carrier to use or disclose
  information about your account and your wireless device, if available, to CMS
  or its service provider for the duration of your business relationship, solely
  to help them identify you or your wireless device and to prevent fraud. See
  our
  <a
    href="https://www.cms.gov/about-cms/information-systems/privacy/privacy-act-1974-and-privacy-act-requests"
    target="_blank"
    >Privacy Policy</a
  >
  for how we treat your data.
</p>
